import { gql } from 'apollo-angular';

export const Query_GetEquipmentCountingJournalCountsByStatus = gql`
  query getEquipmentCountingJournalCountsByStatus(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalCountsByStatus(filter: $filter) {
      status
      count
    }
  }
`;

export const Query_GetEquipmentCountingJournalLineCountsByStatus = gql`
  query getEquipmentCountingJournalLineCountsByStatus(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalLineCountsByStatus(filter: $filter) {
      status
      count
    }
  }
`;

export const Query_GetEquipmentCountingJournalCountsByLocation = gql`
  query getEquipmentCountingJournalCountsByLocation(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalCountsByLocation(filter: $filter) {
      locationNum
      locationName
      count
    }
  }
`;

export const Query_GetEquipmentCountingJournalTrends = gql`
  query getEquipmentCountingJournalTrends(
    $filter: DtoEquipmentCountingJournalMetricsFilter
    $groupBy: String
  ) {
    getEquipmentCountingJournalTrends(filter: $filter, groupBy: $groupBy) {
      date
      totalJournals
      completedJournals
      totalLines
      countedLines
    }
  }
`;

export const Query_GetEquipmentCountingJournalLineCountsByDisposition = gql`
  query getEquipmentCountingJournalLineCountsByDisposition(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalLineCountsByDisposition(filter: $filter) {
      disposition
      count
    }
  }
`;
